import REUAlumni from '../../assets/Image/REUAlumni.jpg';

export const REU_A_2019 = (
    <div>
        <p className="title"><b>2019 REU Alumni</b></p>
        <img className="img-fluid" src={REUAlumni} alt="Image" />
        <p>
            <span className="programs-span">
                <b>Top Row: </b>(Left to right) Jason (Tyler) Arias, John Conan Minihan, Ismael Chavez<br />
                <b>Mid Row: </b>(Left to Right) Leilani Kwe, Flavia DePlachett, Amaris Paramo, Daniel Heredia<br />
                <b>Front Row: </b>(Left to Right) Angel Ha, Jenny Gonzalez, Arantxa Gomez Ferrer, Armando Urbina
            </span>
            <br /><br />
            At the end of the program, each REU student made a presentation at the 2019 UC San Diego Summer Research Conference, summarizing their respective research projects and accomplishments to include lessons learned.
            <br /><br />
            SDNI anticipates that all participants will share their unique and exciting hands-on research experience and other components of the program to include presentation skills and the writing of a personal statement with several students at their respective colleges, and by doing so will promote STEM and more specifically nanotechnology education. This type of impact is in line with The California NanoTech 2025 Project general mission.
            <br /><br />
            <b>The participants’ final presentations can be found below.</b>
            <br /><br />
            <a href="https://drive.google.com/open?id=1Ydaa5r5KhPeKj5T_nfGCj-54VVyfRq6A"><button className="programs-button">REU Final Presentation</button></a>
            <br /><br /><br /><br /><br />
        </p>
    </div>
)